import React from 'react';
import './LegalPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <p className="legal-kicker">Privacy</p>
        <h1>Privacy Policy</h1>
        <p className="legal-meta">Last updated: January 6, 2025</p>
        <p className="legal-lead">
          We keep data collection simple: we store your name, email, and the messages you create so we can route them to the AI provider you choose. We do not sell information, we do not read or train on your messages, and when we deliver your prompts to a provider we do not attach who is asking.
        </p>
      </header>

      <div className="legal-card">
        <section className="legal-section">
          <h3>Information We Collect</h3>
          <ul className="legal-list">
            <li>
              <span className="legal-highlight">Account details:</span> the name and email you provide to register and manage your account.
            </li>
            <li>
              <span className="legal-highlight">Messages you send:</span> the conversation content you create so we can deliver it to the AI provider you select.
            </li>
            <li>
              <span className="legal-highlight">Basic service metadata:</span> non-identifying technical data (such as timestamps and device type) needed to keep the service stable and secure.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>How We Use Your Information</h3>
          <ul className="legal-list">
            <li>Deliver the messages you choose to the AI provider you choose, without attaching your identity to those requests.</li>
            <li>Maintain your account, subscription status, and authentication.</li>
            <li>Provide support and guard against fraud or abuse while avoiding human access to your message content.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>How We Share (and Do Not Share)</h3>
          <ul className="legal-list">
            <li>
              <span className="legal-highlight">No selling or advertising:</span> we do not sell, rent, or trade your personal information.
            </li>
            <li>
              <span className="legal-highlight">AI providers you choose:</span> we only share your message content with the specific AI provider you explicitly select for a given request.
            </li>
            <li>
              <span className="legal-highlight">Identity kept separate:</span> when routing a request, we do not tell the provider who is asking. Provider-facing authentication is handled by our service credentials, not your personal identity.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>Message Handling</h3>
          <p>
            Messages are processed to deliver your prompt and receive a response from the chosen AI provider. We do not inspect or review your messages, and we do not train models on your data. Automated systems may handle routing and safety checks, but human review of message content is not part of normal operations.
          </p>
        </section>

        <section className="legal-section">
          <h3>Your Rights and Controls</h3>
          <ul className="legal-list">
            <li>Delete any message at any time. Deleted messages are removed from active systems.</li>
            <li>Request account deletion to remove your stored name, email, and messages from active use.</li>
            <li>Update your account details through your profile or by contacting support.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>Data Security</h3>
          <p>
            We use industry-standard security controls to protect stored account information and message data in transit and at rest. No method is perfectly secure, but we continuously monitor for vulnerabilities and apply safeguards to minimize risk.
          </p>
        </section>

        <section className="legal-section">
          <h3>Contact Us</h3>
          <p>
            Questions or requests about this policy can be sent to support@arrow.ai. We are committed to resolving privacy concerns promptly.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
